import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./../../../../assets/css/general/Homelayout/ApplySection/ApplySection.css";

const ApplySection = () => {
  const navigate = useNavigate();

  const handleApplyClick = () => {
    sessionStorage.setItem("scrollPosition", window.scrollY);
    navigate("/apply");
  };

  return (
    <section className="as-hero-section">
      {/* Abstract Background Shapes */}
      <div className="as-bg-shape as-shape-top-left"></div>
      <div className="as-bg-shape as-shape-top-center"></div>
      <div className="as-bg-shape as-shape-bottom-left"></div>
      <div className="as-bg-shape as-shape-right-large"></div>

      <Container className="as-hero-container">
        <Row className="as-hero-row align-items-center">
          {/* Left Side - Organic Image Container */}
          <Col xs={12} lg={6} className="as-left-section">
            <div className="as-image-blob-container">
              {/* Maroon/Red Overlay Shapes */}
              <div className="as-overlay-shape as-shape-primary"></div>
              <div className="as-overlay-shape as-shape-secondary"></div>

              {/* Main Image with Organic Frame */}
              <div className="as-organic-image-frame">
                <img
                  src="https://images.pexels.com/photos/6592558/pexels-photo-6592558.jpeg"
                  alt="Professional mentorship session"
                  className="as-hero-image"
                />
              </div>

              {/* Floating Badge */}
              <div className="as-floating-badge">
                <svg
                  className="as-badge-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    d="M22 11.08V12a10 10 0 1 1-5.93-9.14"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    points="22 4 12 14.01 9 11.01"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="as-badge-text">
                  <span className="as-badge-number">300+</span>
                  <span className="as-badge-label">Verified Mentors</span>
                </div>
              </div>
            </div>
          </Col>

          {/* Right Side - Content */}
          <Col xs={12} lg={6} className="as-right-section">
            {/* Laptop Background Image */}
            <div className="as-laptop-bg-overlay">
              <img
                src="https://images.pexels.com/photos/7974/pexels-photo.jpg"
                alt=""
                className="as-laptop-bg-image"
              />
            </div>

            <div className="as-content-container">
              <span className="as-section-badge">Start Your Journey</span>

              <h1 className="as-hero-title">
                Bridge the gap between <strong>learning</strong> and{" "}
                <strong>earning</strong>
              </h1>

              <p className="as-hero-subtitle">
                Connect with industry experts who have walked your path. Get
                personalized mentorship, real-world insights, and the guidance
                you need to succeed.
              </p>

              <div className="as-features-list">
                <div className="as-feature-item">
                  <svg
                    className="as-feature-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <polyline
                      points="20 6 9 17 4 12"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>1-on-1 mentorship sessions</span>
                </div>
                <div className="as-feature-item">
                  <svg
                    className="as-feature-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <polyline
                      points="20 6 9 17 4 12"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>Industry-specific guidance</span>
                </div>
                <div className="as-feature-item">
                  <svg
                    className="as-feature-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <polyline
                      points="20 6 9 17 4 12"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>Career roadmap development</span>
                </div>
              </div>

              <div className="as-cta-wrapper">
                <button
                  className="as-cta-btn as-cta-primary"
                  onClick={handleApplyClick}
                >
                  Get Started
                  <svg
                    className="as-btn-arrow"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <line
                      x1="5"
                      y1="12"
                      x2="19"
                      y2="12"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <polyline
                      points="12 5 19 12 12 19"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button
                  className="as-cta-btn as-cta-secondary"
                  onClick={() => navigate("/mentors")}
                >
                  Browse Mentors
                </button>
              </div>

              <div className="as-trust-indicator">
                <div className="as-trust-avatars">
                  <div className="as-avatar"></div>
                  <div className="as-avatar"></div>
                  <div className="as-avatar"></div>
                  <div className="as-avatar as-avatar-more">+10k</div>
                </div>
                <div className="as-trust-text">
                  <div className="as-rating">
                    <svg
                      className="as-star"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                    <span>4.9/5</span>
                  </div>
                  <span className="as-trust-label">from 10,000+ learners</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ApplySection;
